export default function InferredExtractedEditedIco() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" transform="matrix(-1 0 0 1 13 3)" fill="#475E75"/>
            <circle cx="15" cy="14" r="3" fill="#049F9A"/>
            <circle cx="3" cy="3" r="3" transform="matrix(-1 0 0 1 8 11)" fill="#0070F2"/>
        </svg>
    )
}